<template>
<!--	<transition enter-active-class="animated slideInLeft faster">-->
<!--		-->
<!--	</transition>-->
	<div class="sidebar" data-color="blue" data-active-color="warning">
		<!--
    Tip 1: You can change the color of the sidebar using: data-color="blue | green | orange | red | yellow"
-->
		<div class="logo">
			<a href="https://www.bigscoots.com/" class="simple-text logo-mini" v-if="sidebarMini === true">
				<div class="logo-image-small">
					<img src="../../assets/img/bigscoots-logo/bigscoots-logo-mascot-white.svg">
				</div>
			</a>
			<a href="https://www.bigscoots.com/" target="_blank" class="simple-text" v-if="sidebarMini === false">
				<div class="logo-image-big">
					<img src="../../assets/img/bigscoots-logo/logo_light.svg" alt="BigScoots" width="70%" class="center">
				</div>
			</a>
		</div>
		<div class="sidebar-wrapper">
			<div class="user">
				<div class="photo">
					<img :src="`https://www.gravatar.com/avatar/${userEmailHash}?s=34`" />
				</div>
				<div class="info">
					<a data-toggle="collapse" href="#collapseExample" class="collapsed">
							<span>
								{{ userFullName }}
								<br>
								<small>{{ userEmail }}</small>
								<b class="caret"></b>
							</span>
					</a>
					<div class="clearfix"></div>
					<div class="collapse" id="collapseExample">
						<ul class="nav">
							<router-link tag="li" :to="{ name: 'editUserProfile' }" exact-active-class="active">
								<a>
									<span class="sidebar-mini-icon">EP</span>
									<span class="sidebar-normal">Edit Profile</span>
								</a>
							</router-link>
						</ul>
					</div>
				</div>
			</div>
			<ul class="nav">
				<router-link tag="li" :to="{ name: 'userDashboard' }" exact-active-class="active">
					<a>
						<i class="fa fa-home"></i>
						<p>Dashboard</p>
					</a>
				</router-link>
				<router-link v-if="!isCollaborator && !hideSiteDetails" tag="li" :to="{ name: 'siteDetails' }" :class="{'active': (this.$route.path.substring(0, 7) === '/sites/' && $route.query.tab !== 'backups' && !this.$route.path.includes('server-logs') )}">
					<a>
						<i class="fa fa-server"></i>
						<p>Site Details</p>
					</a>
				</router-link>
				<router-link v-if="!isCollaborator" tag="li" :to="{ name: 'migrationLog' }" exact-active-class="active">
					<a>
						<i class="fa fa-database"></i>
						<p>Migrations</p>
					</a>
				</router-link>
				<router-link tag="li" v-if="hostingAccounts.length > 0 && !isAllAccountPending && !isWatchSupervisor && !isCollaborator" :to="{ name: 'viewDetails', params: { index: encryptIndex( getFirstActiveAccountIndex() ) }, query: { tab: 'backups' } }"
						:class="{'active': $route.query.tab === 'backups' && this.$route.path.substring(0, 7) === '/sites/'}">
					<a>
						<i class="fa fa-hdd-o"></i>
						<p>Backups</p>
						</a>
					</router-link>
					<router-link v-if="!isNewAccount" tag="li" :to="{ name: 'Collaborators' }"
						:class="{'active': (this.$route.path.substring(0, 15) === '/collaborators/' || this.$route.path.substring(0, 14) === '/collaborator/')}">
						<a>
							<i class="fa fa-users"></i>
							<p>Collaborators</p>
					</a>
				</router-link>
				<router-link tag="li" v-if="!isCollaborator" :to="{ name: 'ticketsArchive' }" exact-active-class="active">
					<a>
						<i class="fa fa-ticket"></i>
						<p>Support Tickets</p>
					</a>
				</router-link>
				<router-link tag="li" v-if="!isCollaborator" :to="{ name: 'openTicket' }" exact-active-class="active">
					<a>
						<i class="fa fa-envelope"></i>
						<p>Open New Ticket</p>
					</a>
				</router-link>

				<!-- v-if="!isNewAccount && !isAllAccountPending && !isCollaborator " -->

				<router-link tag="li" :to="{ name: 'email' }" exact-active-class="active">
					<a>
						<i class="fa fa-envelope-open"></i>
						<p>Email</p>
					</a>
				</router-link>
<!--				<router-link tag="li" v-if="hostingAccounts.length > 0 && !isWatchSupervisor" :to="{ name: 'logs' }" exact-active-class="active"-->
<!--							:class="{ 'active' : (this.$route.path.includes('server-logs'))}">-->
<!--					<a>-->
<!--						<i class="fa fa-history" style="color: rgba(255, 255, 255, 0.5) !important;"></i>-->
<!--						<p>PHP Error Logs</p>-->
<!--					</a>-->
<!--				</router-link>-->
			</ul>
		</div>
	</div>
</template>

<script>
import AES from 'crypto-js/aes';
import $ from "jquery/dist/jquery.slim.min";
import PerfectScrollbar from "perfect-scrollbar";
let sidebar = null;

export default {
  name: "UserSideMenu",
  computed: {
    sidebarMini() {
      return this.$store.getters["sidebarMini/type"]
    },
    userFullName() {
      return this.$store.getters.userFullName;
    },
    userEmail() {
      return this.$store.getters.userEmail;
    },
    userEmailHash() {
      return this.$store.getters.emailHashGravatar;
    },
    aesSecret() {
      return this.$store.getters["crypto/aesSecret"];
    },
    hostingAccounts() {
      return this.$store.getters["hosting/accountsOrdered"];
    },
	isWatchSupervisor(){
		return this.$store.getters['hosting/isWatchingSupervisorAccounts'];
	},
	isNewAccount () {
		const hostingDetail = this.$store.getters["hosting/accounts"];
		return (hostingDetail && hostingDetail[0] && hostingDetail[0].primary.domain === '');
	},
  hideSiteDetails () {
    const hostingDetail = this.$store.getters["hosting/accounts"];
    return (hostingDetail.length <= 0);
  },
	isAllAccountPending () {
    	let allPending = true;
    	this.hostingAccounts.forEach(acc => {
    		if (acc.status === 'active') {
    			allPending = false;
			}
		});
    	return allPending;
	},
    customerID() {
      return this.$store.getters.getCustomerID;
    },
    isCollaborator () {
      return this.hostingAccounts.length <= 0 && this.customerID === '-1'
    },
    queryListener(){
      return this.$store.getters['alert/queryListener'];
    },
  },
  mounted() {
      const isWindows = navigator.platform.indexOf("Win") > -1 ? true : false;

    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      sidebar = new PerfectScrollbar(".sidebar .sidebar-wrapper");
      sidebar.update();
      //$('.sidebar .sidebar-wrapper, .main-panel').perfectScrollbar();

      $("html").addClass("perfect-scrollbar-on");
    } else {
      $("html").addClass("perfect-scrollbar-off");
    }
    this.$store.dispatch('alert/createRealTimeSnapShotOnHbMapping');
  },
  methods:{
    encryptIndex(index) {
      return AES.encrypt(index, this.aesSecret).toString()
    },
	getFirstActiveAccountIndex () {
    	let firstActiveAccountIndex = -1;
    	for (let index in this.hostingAccounts){
    		if(this.hostingAccounts[index].status === 'active') {
				firstActiveAccountIndex = index;
				break;
			}
		}
    	return firstActiveAccountIndex;
	}
  },
	beforeDestroy() {
		if(sidebar){
			sidebar.destroy();
		}
    if(this.queryListener){
      console.log('detach disk usage alert listener');
      this.queryListener();
      this.$store.commit('alert/updateDiskAlert', {});
    }
		sidebar = null;
	}
};
</script>

<style lang="scss">
.logo {
	min-height: 68px;
}
</style>
